export const activityLogsPages = [
  {
    path: 'activity-log',
    props: true,
    component: () => import('@/views/activityLog/TheActivityLogPage.vue'),
    children: [
      {
        path: '',
        name: 'activity_log_route'
      },
      {
        path: ':date',
        name: 'activity_log_date_route'
      }
    ]
  }
]
